import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PageHero } from "./Properties";
import { Seo } from "@/components/site/Seo";
import { useLang } from "@/lib/i18n";
import { useSite, mediaUrl } from "@/lib/site";

export default function Destinations() {
  const { t, tr } = useLang();
  const { countries } = useSite();
  return (
    <main data-testid="destinations-page">
      <Seo title={t.nav.destinations} path="/destinacie" />
      <PageHero img="/img/santorini.jpg" eyebrow={t.destEyebrow} title={t.destTitle} />
      <section className="bg-ivory py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {countries.map((c, i) => (
            <motion.div key={c.id} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, delay: (i % 3) * 0.1 }}>
              <Link to={`/nehnutelnosti?country=${c.id}`} data-testid={`destination-card-${c.slug}`} className="group relative block aspect-[3/4] overflow-hidden bg-midnight">
                <img src={mediaUrl(c.image)} alt={tr(c.name)} loading="lazy" className="w-full h-full object-cover opacity-85 transition-transform duration-[1.6s] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-midnight/90 via-midnight/10 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-8">
                  <div className="text-[10px] tracking-[0.4em] text-gold">{String(i + 1).padStart(2, "0")}</div>
                  <h2 className="font-display text-4xl text-ivory mt-2">{tr(c.name)}</h2>
                  <p className="text-sm text-ivory/75 mt-2">{c.regions?.map((r) => tr(r.name)).join(" · ")}</p>
                  <span className="block h-px bg-gold mt-6 w-10 group-hover:w-full transition-[width] duration-700" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
}
